/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
	GET_WMI_CREDENTIALS,
	FETCH_WMI_CREDENTIALS_SUCCESS,
	FETCH_WMI_CREDENTIALS_FAILURE,
	POLL_WMI_START,
	POLL_WMI_STOP,
	DELETE_WMI_CRED,
	UPDATE_WMI_CRED,
	ADDED_WMI_CRED,
	ADDED_SNMP_CRED,
	GET_SNMP_CREDENTIALS,
	FETCH_SNMP_CREDENTIALS_FAILURE,
	FETCH_SNMP_CREDENTIALS_SUCCESS,
	POLL_SNMP_START,
	POLL_SNMP_STOP,
	DELETE_SNMP_CRED,
	UPDATE_SNMP_CRED
} from './actionTypes'

//Get WMI Credentials
export function getWMI() {
	  return {
	    type: GET_WMI_CREDENTIALS,
	  }
	}

export function fetchWMISuccess(json) {
	  return {
	    type: FETCH_WMI_CREDENTIALS_SUCCESS,
	    credentials: json
	  }
}

 export function fetchWMIFailure(error) {
	  return {
	    type: FETCH_WMI_CREDENTIALS_FAILURE,
	    errorMessage: error.message
	  }
}
 
 export function pollWmiCredStart() {
	  return {
	    type:POLL_WMI_START
	  }
	}

	export function pollWmiCredStop() {
	  return {
	    type:POLL_WMI_STOP
	  }
	}
	//get snmp 
	export function getSNMP() {
		return {
		  type: GET_SNMP_CREDENTIALS,
		}
	  }
  
  export function fetchsnmpSuccess(json) {
		return {
		  type: FETCH_SNMP_CREDENTIALS_SUCCESS,
		  credentials: json
		}
  }
  
   export function fetchsnmpFailure(error) {
		return {
		  type: FETCH_SNMP_CREDENTIALS_FAILURE,
		  errorMessage: error.message
		}
  }
   
   export function pollsnmpCredStart() {
		return {
		  type:POLL_SNMP_START
		}
	  }
  
	  export function pollsnmpCredStop() {
		return {
		  type:POLL_SNMP_STOP
		}
	  }
	//end
	export function deleteWmiCred(deletedItem) {
		  return {
		    type:DELETE_WMI_CRED,
		    deletedCredential: deletedItem
		  }
		}
	export function updateWmiCred(updatedItem) {
		  return {
		    type:UPDATE_WMI_CRED,
		    updatedCredential: updatedItem
		  }
		}
	
	export function addWmiCred(addedItem) {
		  return {
		    type:ADDED_WMI_CRED,
		    addedCredential: addedItem
		  }
		}
		export function addSNMP(addedItem) {
			return {
			  type:ADDED_SNMP_CRED,
			  addedCredentialSNMP: addedItem
			}
		  }
		  export function deleteSNMPCred(deletedItem) {
			return {
			  type:DELETE_SNMP_CRED,
			  deletedCredentialSNMP: deletedItem
			}
		  }
		  export function updateSNMPCred(updatedItem) {
			return {
			  type:UPDATE_SNMP_CRED,
			  updatedCredential: updatedItem
			}
		  }
		
		  